import React from 'react';

function Map() {
  return (
    <div className="map-container" aria-labelledby="map-heading">
      <h2 id="map-heading" className="visually-hidden">Localização da Front BPO</h2>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3655.811392951336!2d-46.7064246850212!3d-23.61085898465918!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5a2d0f0d0d4d%3A0x8e8f8f8f8f8f8f8f!2sAv.%20das%20Nacoes%20Unidas%2C%2014261%20-%20Vila%20Gertrudes%2C%20Sao%20Paulo%20-%20SP%2C%2004794-000!5e0!3m2!1spt-BR!2sbr!4v1672880000000"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Endereço da Front BPO no Google Maps"
      ></iframe>
    </div>
  );
}

export default Map;
